/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

/**
 * Filter module for pluralization.
 */
angular
  .module('filters.pluralize', ['filters.i18n'])
  /**
   * Filter used for pluralizing strings.
   *
   * @param {int} total The number to evaluate whether to return the plural or singular version of the string.
   * @param {String} single The singular key of the string to use.
   * @param {String} plural The plural key of the string to use. The key must match a string that expects a single argument that is the count.
   * @returns The resource string.
   */
  .filter('pluralize', function ($filter) {
    return function (total, singleString, pluralString) {
      if (total === 1) {
        return $filter('i18n')(singleString);
        // Check number type.
      } else if (!isNaN(parseFloat(total)) && isFinite(total)) {
        return $filter('i18n')(pluralString, [$filter('number')(total)]);
      } else {
        return '';
      }
    };
  });
